module.exports = __webpack_public_path__ + "img/message.1cbc2f07.png";